import { IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonGrid, IonRow } from '@ionic/react'
import { useLiveQuery } from 'dexie-react-hooks'
import { FC, useState } from 'react'

import db from 'mobile_web/modules/db'
import strings from 'mobile_web/strings'
import { ScreenSection } from 'mytours-read-common'
import SectionHeader from './SectionHeader'
import '../styles/sectionBadgeGroup.less'
import BadgeCard from '../../../badges/components/BadgeCard'
import BadgeGroupCard from '../../../badges/components/BadgeGroupCard'
import Button from '../../../common/components/Button'
import Modal from '../../../common/components/modal'
import { getDirMode } from '../../../platform'

interface SectionBadgeGroupProps {
	section: ScreenSection
}

const SectionBadgeGroup: FC<SectionBadgeGroupProps> = ({ section }) => {
	const [selectedBadgeGroupId, setSelectedBadgeGroupId] = useState<number>(null)
	const badgeGroup = useLiveQuery(() => db.badgeGroups.get({ id: selectedBadgeGroupId || -1 }), [selectedBadgeGroupId])
	const badges = useLiveQuery(() => db.badges.where({ group_id: selectedBadgeGroupId || -1 }).toArray(), [selectedBadgeGroupId]) || []
	const recentlyEarnedBadges = useLiveQuery(() => db.recentlyEarnedBadges.toArray())
	const allEarnedBadges = recentlyEarnedBadges ? recentlyEarnedBadges.map((badge) => badge.badge_id) : []
	const earnedBadges = badges.filter(badge => allEarnedBadges.includes(badge.id));

	const onDidDismiss = () => {
		setSelectedBadgeGroupId(null)
	}

	return (
		<IonGrid className="section-badge-group" dir={getDirMode()}>
			<SectionHeader title={section.title} />
			<IonRow className="block-content" data-cy="story-screen-section-content">
				{section.section_items?.map(badgeItem => {
					if (badgeItem.badge_id) {
						return <BadgeCard key={`badge-${badgeItem.badge_id}`} id={badgeItem.badge_id} />
					} else if (badgeItem.badge_group_id) {
						return <BadgeGroupCard key={`badge-group-${badgeItem.badge_group_id}`} id={badgeItem.badge_group_id} toggleBadgeGroupModal={() => setSelectedBadgeGroupId(badgeItem.badge_group_id)} />
					}
				})}
			</IonRow>

			<Modal isOpen={!!selectedBadgeGroupId} onDidDismiss={onDidDismiss} cssClass="badge-group-modal">
				<IonCard>
					<IonCardHeader className="badge-group-modal-header">
						<IonCardTitle>{badgeGroup?.title}</IonCardTitle>
						<Button className="close" onClick={onDidDismiss} ariaLabel={strings.close}>
							<i className="fal fa-xmark" />
						</Button>
					</IonCardHeader>
					<IonCardContent className="badge-group-modal-content">
						{badges
							.filter(badge => badge.visible_on_badge_list || earnedBadges.find(earnedBadge => earnedBadge.id === badge.id))
							.sort((a, b) => a.position - b.position)
							.map(badge => <BadgeCard key={badge.id} id={badge.id} />)}
					</IonCardContent>
				</IonCard>
			</Modal>
		</IonGrid>
	)
}

export default SectionBadgeGroup
